export default __webpack_public_path__ + "static/media/weathernow.48f857c0.png";